import { DispatcherEvent } from '@carvana/merch-native';
import { useContext, useEffect, useRef } from 'react';
import { usePagination } from '@/srp/ResultsSection/hooks';
import InventoryContext from '~/context/srp/InventoryContext';
import { SearchDispatcherEvent } from '~/native/srp/dispatchers/constants';
import { navPerformanceNow } from '~/utilities/navigationTiming';
import sendMessageToNative from './sendMessageToNative';

export default function usePageReadyDispatcher() {
  const {
    pagination: { totalMatchedInventory }
  } = usePagination();
  const pageReady = useRef(false);
  const {
    inventory: {
      data: { searchRequestId },
      isLoading,
      isLoaded
    }
  } = useContext(InventoryContext);

  const isSearchComplete = Boolean(searchRequestId) && !isLoading && isLoaded;

  useEffect(() => {
    // Send new inventory message to native when total matched inventory changes
    if (pageReady.current) {
      sendMessageToNative(SearchDispatcherEvent.NewInventory, {
        resultCount: totalMatchedInventory
      });
    }
  }, [totalMatchedInventory, searchRequestId]);

  useEffect(() => {
    // Send page ready message to native when search is complete
    if (!pageReady.current && isSearchComplete) {
      sendMessageToNative(DispatcherEvent.PageReady, {
        resultCount: totalMatchedInventory,
        navigationToNowMs: navPerformanceNow()
      });
      pageReady.current = true;
    }
  }, [totalMatchedInventory, isSearchComplete]);
}
